<template>
  <v-list-item :to="route" color="accent">
    <v-list-item-icon>
      <v-icon v-text="positionIcon" />
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title v-text="title" />
    </v-list-item-content>
    <v-list-item-icon v-if="sessionOpened">
      <ag-confirm-dialog
        :title="$t('general.confirmation')"
        :message="statusAction.confirmMessage"
        :cancel-label="$t('general.cancel')"
        :confirm-label="statusAction.confirmButton"
        validation-btn-color="accent"
        @confirm="statusAction.handler"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :color="statusAction.color"
            :loading="loading"
            style="height: 24px; width: 24px;"
            x-small
            fab
            outlined
            v-bind="attrs"
            @click.stop.prevent="on.click"
          >
            <v-icon small v-text="statusAction.icon" />
          </v-btn>
        </template>
      </ag-confirm-dialog>
    </v-list-item-icon>
  </v-list-item>
</template>

<script>
import Repositories from 'src/repositories'
import { mapActions } from 'vuex'
import AgConfirmDialog from 'src/components/common/AgConfirmDialog'

export default {
  name: 'GameSessionListItem',
  components: {
    AgConfirmDialog,
  },
  props: {
    game: {
      type: Object,
      required: true,
    },
    sessionOpened: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    gameId () {
      return this.game.resourceId
    },
    title () {
      return this.$t(`animation.menu.games.${this.game.name}`)
    },
    route () {
      const baseUrl = `/animation/session/${this.game.sessionId}/games`
      return `${baseUrl}/${this.game.name}/${this.gameId}`
    },
    positionIcon () {
      return `mdi-numeric-${this.game.position}-circle`
    },
    openButton () {
      return {
        icon: 'mdi-lock-open-outline',
        color: 'accent',
        handler: this.open,
        confirmMessage: this.$t('animation.menu.game.opened.confirmMessage'),
        confirmButton: this.$t('animation.menu.game.opened.confirmButton'),
      }
    },
    finishButton () {
      return {
        icon: 'mdi-stop',
        color: 'primary',
        handler: this.finish,
        confirmMessage: this.$t('animation.menu.game.finished.confirmMessage'),
        confirmButton: this.$t('animation.menu.game.finished.confirmButton'),
      }
    },
    reopenButton () {
      return {
        icon: 'mdi-play',
        color: 'secondary',
        handler: this.open,
        confirmMessage: this.$t('animation.menu.game.opened.confirmMessage'),
        confirmButton: this.$t('animation.menu.game.opened.confirmButton'),
      }
    },
    statusAction () {
      return {
        closed: this.openButton,
        opened: this.finishButton,
        finished: this.reopenButton,
      }[this.game.status]
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    ...mapActions('animation', {
      patchGame: 'patchGame',
    }),
    async patch ({ patch, successMessage, errorMessage }) {
      this.loading = true
      try {
        await Repositories.animation.game.patch(patch)
        this.patchGame(patch)
        this.showSuccessNotification(successMessage)
      }
      catch (error) {
        this.showErrorNotification(errorMessage)
      }
      finally {
        this.loading = false
      }
    },
    open () {
      const { sessionId, id } = this.game
      this.patch({
        patch: { sessionId, id, status: 'opened' },
        successMessage: this.$t('animation.menu.game.opened.success'),
        errorMessage: this.$t('animation.menu.game.opened.error'),
      })
    },
    finish () {
      const { sessionId, id } = this.game
      this.patch({
        patch: { sessionId, id, status: 'finished' },
        successMessage: this.$t('animation.menu.game.finished.success'),
        errorMessage: this.$t('animation.menu.game.finished.error'),
      })
    },
  },
}
</script>
